import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CATEGORY_ICONS, DEFAULT_CATEGORY_ICON } from 'constants/ascii';

function CategoryCard({ category, index }) {
  const { t } = useTranslation();
  const icon = CATEGORY_ICONS[category.slug] || DEFAULT_CATEGORY_ICON;
  const num = String(index + 1).padStart(2, '0');

  return (
    <Link to={`/categories/${category.slug}`} className="cat-card">
      <div className="cat-card-header">
        <span className="cat-num">{num} —</span>
        <pre className="cat-icon">{icon}</pre>
      </div>
      <div className="cat-name">{category.name}</div>
      {category.description && (
        <p className="cat-desc">{category.description}</p>
      )}
      <span className="cat-arrow">
        {t('catalog.browseCategory', { name: category.name })}
      </span>
    </Link>
  );
}

export default CategoryCard;
